import { render, staticRenderFns } from "./Taobao-expendType.vue?vue&type=template&id=b86e4086&"
import script from "./Taobao-expendType.vue?vue&type=script&lang=js&"
export * from "./Taobao-expendType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports